import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import {
  AddCardIssuePointOpts,
  AddressSuggesterService,
  AppAuthService,
  CardIssuePointsService,
  Id,
  MunicipalEntitiesService,
  UsersService,
} from '@prodcard/core'
import { CardHeader } from '../../../../components'
import CardIssuePointForm from './CardIssuePointForm.vue'
import { createCtx, handleError, callSuccessToast } from '../../../../helpers'
import { pickBy } from 'lodash'
import { publishResult } from '../../../../helpers/useResult'


export default /*#__PURE__*/_defineComponent({
  __name: 'CardIssuePointNewPage',
  props: {
    authService: {},
    usersService: {},
    municipalEntitiesService: {},
    cardIssuePointsService: {},
    addressSuggesterService: {},
    resultId: {}
  },
  setup(__props: any) {

const props = __props;



const router = useRouter()
const loading = ref(false)

const submit = (opts: AddCardIssuePointOpts) => {
  handleError(async () => {
    const id = await props.cardIssuePointsService.add(createCtx(), pickBy(opts, o => !!o) as AddCardIssuePointOpts)

    if (props.resultId) {
      publishResult(props.resultId, id)
    } else {
      callSuccessToast('Пункт выдачи карт создан')
    }
    router?.back()
  }, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardHeader), null, {
            title: _withCtx(() => [
              _createTextVNode(" Новый пункт выдачи карт ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "mt-8 pa-0" }, {
        default: _withCtx(() => [
          _createVNode(CardIssuePointForm, {
            "address-suggester-service": _ctx.addressSuggesterService,
            "auth-service": _ctx.authService,
            "users-service": _ctx.usersService,
            "municipal-entities-service": _ctx.municipalEntitiesService,
            "card-issue-points-service": _ctx.cardIssuePointsService,
            loading: loading.value,
            onSubmit: submit
          }, null, 8, ["address-suggester-service", "auth-service", "users-service", "municipal-entities-service", "card-issue-points-service", "loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})